import { Injectable, inject } from '@angular/core';

import {
    ClientConfig,
    ClientConfigProductName,
    ClientConfigService,
    LazyClientConfig,
    LazyClientConfigService,
    StylesService,
} from '@frontend/vanilla/core';

@ClientConfig({ key: 'paAssets', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: AssetsDataFactory,
    deps: [ClientConfigService],
})
export class AssetsData {
    imageVariablesCSS!: string;
    assets!: {
        achinterchecks?: { [key: string]: string };
        brazilimages?: { [key: string]: string };
        footerlogos?: { [key: string]: string };
        managebankaccount?: { [key: string]: string };
        miscimages?: { [key: string]: string };
        transactionhistory?: { [key: string]: string };
        truelayerlogos?: { [key: string]: string };
        videos?: { [key: string]: string };
    };
}

export function AssetsDataFactory(clientConfigService: ClientConfigService) {
    const data = clientConfigService.get(AssetsData);
    const stylesService: StylesService = inject(StylesService);
    stylesService.addStyle('payments-image-variables', data.imageVariablesCSS);
    return data;
}

@ClientConfig({ key: 'paCashier', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: PaymentsCashierConfigFactory,
    deps: [ClientConfigService],
})
export class PaymentsCashierConfig {
    host!: string;
    ngpgHost!: string;
    enableAppV2!: boolean;
}

export function PaymentsCashierConfigFactory(clientConfigService: ClientConfigService) {
    return clientConfigService.get(PaymentsCashierConfig);
}

@ClientConfig({ key: 'paCommon', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: PaymentsCommonConfigFactory,
    deps: [ClientConfigService],
})
export class PaymentsCommonConfig {
    sprinklrEnabled!: boolean;
    siftEnabled!: boolean;
    scriptsInjectionData!: { [key: string]: { url: string; customAttributes: { [key: string]: string }; styleSheetUrl: string } };
}

export function PaymentsCommonConfigFactory(clientConfigService: ClientConfigService) {
    return clientConfigService.get(PaymentsCommonConfig);
}

@LazyClientConfig({ key: 'paQuickDeposit', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: QuickDepositConfigFactory,
    deps: [LazyClientConfigService],
})
export class QuickDepositConfig {
    applepayEnabled!: boolean;
}

export function QuickDepositConfigFactory(clientConfigService: LazyClientConfigService) {
    return clientConfigService.get(QuickDepositConfig);
}

@LazyClientConfig({ key: 'paLinks', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: LinksConfigFactory,
    deps: [LazyClientConfigService],
})
export class LinksConfig {
    links!: Links;
}

export function LinksConfigFactory(clientConfigService: LazyClientConfigService) {
    return clientConfigService.get(LinksConfig);
}

@ClientConfig({ key: 'paKyx', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: PaymentsKyxConfigFactory,
    deps: [ClientConfigService],
})
export class PaymentsKyxConfig {
    bankAccountsFacialEnabled!: boolean;
    nonFtdFacialEnabled!: boolean;
    ftdFacialEnabled!: boolean;
    facialConsentTimeout!: number;
}

export function PaymentsKyxConfigFactory(clientConfigService: ClientConfigService) {
    return clientConfigService.get(PaymentsKyxConfig);
}

@ClientConfig({ key: 'paGooglepay', product: ClientConfigProductName.PAYMENTS })
@Injectable({
    providedIn: 'root',
    useFactory: GooglePayConfigFactory,
    deps: [ClientConfigService],
})
export class GooglePayConfig {
    environment!: string;
    isEnabled!: string;
    merchantId!: string;
    merchantName!: string;
    publicKey!: string;
}
export function GooglePayConfigFactory(clientConfigService: ClientConfigService) {
    return clientConfigService.get(GooglePayConfig);
}

interface LinkAttributes {
    target?: '_self' | '_blank' | '_parent' | '_top';
}

interface LinkItem {
    url: string;
    text: string;
    attributes?: LinkAttributes;
}

interface Links {
    [key: string]: LinkItem;
}
